import React from 'react';
import PropTypes from 'prop-types';
import {WarningIcon} from '../../Icons';
import {Image} from '@learningblocks/shared-components';
import className from './style.module.scss';

function ComponentBody(props) {
  return (
    <>
      <div className={className.body_ImageBlock}>
        <Image src={props.image} alt='warning-toast' />
      </div>
      <div className={className.body_TextBlock}>
        <h5>{props.title}</h5>
        <p>{props.message}</p>
      </div>
    </>
  );
}

ComponentBody.propTypes = {
  /**
   * Title of the toast
   */
  title: PropTypes.string,
  /**
   * message of the toast
   */
  message: PropTypes.string,
  /**
   * image of the toast
   */
  image: PropTypes.string,
  /**
   * closeToast [ injected by library]
   */
  closeToast: PropTypes.func,
  /**
   * toastProps [ injected by library]
   */
  toastProps: PropTypes.object,
};

ComponentBody.defaultProps = {
  image: WarningIcon,
};

export const WarningToast = {
  className: className.warningToast,
  bodyClassName: className.body,
  progressClassName: className.progress,
  Body: ComponentBody,
};
